var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-top px-3 py-2"},[_c('div',[_c('div',{staticClass:"mr-2 font-weight-regular oc-text-shadow"},[_vm._v(" "+_vm._s(_vm.user.name)+" ")]),(_vm.user.specialty)?_c('div',{staticClass:"font-weight-light oc-text-shadow",staticStyle:{"line-height":".8"}},[_c('small',[_vm._v(_vm._s(_vm.user.specialty.name))])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }